import Broker from "../views/Broker";

import KartaKlienti from "../containers/broker/KartaKlienti/KartaKlienti";
import KartaHypoteky from "../containers/broker/KartaHypoteky/KartaHypoteky";
import KartaHypotekyDetail from "../containers/broker/KartaHypoteky/KartaHypotekyDetail";
import KartaZiadosti from "../containers/broker/KartaZiadosti/KartaZiadosti";
import KartaPosudky from "../containers/expert/KartaPosudky/KartaPosudky";
import KartaServis from "@/containers/broker/KartaServis/KartaServis.vue";



const brokerRoutes = {
  name: "RoleRoutes",
  component: Broker,
  path: "",
  redirect: KartaHypoteky,
  children: [
    
    {
      name: "KartaHypoteky",
      component: KartaHypoteky,
      path: "/karta-hypoteky/",
    },
    {
      name: "KartaHypotekyDetail",
      component: KartaHypotekyDetail,
      path: "/karta-hypoteky/:hypoteka/detail",
    },
    {
      name: "KartaKlienti",
      component: KartaKlienti,
      path: "/karta-klienti/",
    },
    {
      name: "KartaPosudky",
      component: KartaPosudky,
      path: "/karta-posudky/",
    },
    {
      name: "KartaServis",
      component: KartaServis,
      path: "/karta-servis/",
    },
    {
      name: "KartaZiadosti",
      component: KartaZiadosti,
      path: "/karta-ziadosti/",
    },
  ],
}

export default brokerRoutes;
